export interface Country {
  name: {
    common: string;
    official: string;
  };
  cca2: string;
  cca3: string;
  flags: {
    png: string;
    svg: string;
  };
  region: string;
  subregion?: string;
  capital?: string[];
  population: number;
}

/** Local countries dataset used by CountryService (replaces restcountries API). */
export const COUNTRIES: Country[] = [
  {
    name: { common: "Afghanistan", official: "Afghanistan" },
    cca2: "AF",
    cca3: "AFG",
    flags: {
      png: "https://flagcdn.com/w40/af.png",
      svg: "https://flagcdn.com/af.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Albania", official: "Albania" },
    cca2: "AL",
    cca3: "ALB",
    flags: {
      png: "https://flagcdn.com/w40/al.png",
      svg: "https://flagcdn.com/al.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Algeria", official: "Algeria" },
    cca2: "DZ",
    cca3: "DZA",
    flags: {
      png: "https://flagcdn.com/w40/dz.png",
      svg: "https://flagcdn.com/dz.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Andorra", official: "Andorra" },
    cca2: "AD",
    cca3: "AND",
    flags: {
      png: "https://flagcdn.com/w40/ad.png",
      svg: "https://flagcdn.com/ad.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Angola", official: "Angola" },
    cca2: "AO",
    cca3: "AGO",
    flags: {
      png: "https://flagcdn.com/w40/ao.png",
      svg: "https://flagcdn.com/ao.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Antigua and Barbuda", official: "Antigua and Barbuda" },
    cca2: "AG",
    cca3: "ATG",
    flags: {
      png: "https://flagcdn.com/w40/ag.png",
      svg: "https://flagcdn.com/ag.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Argentina", official: "Argentina" },
    cca2: "AR",
    cca3: "ARG",
    flags: {
      png: "https://flagcdn.com/w40/ar.png",
      svg: "https://flagcdn.com/ar.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Armenia", official: "Armenia" },
    cca2: "AM",
    cca3: "ARM",
    flags: {
      png: "https://flagcdn.com/w40/am.png",
      svg: "https://flagcdn.com/am.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Australia", official: "Australia" },
    cca2: "AU",
    cca3: "AUS",
    flags: {
      png: "https://flagcdn.com/w40/au.png",
      svg: "https://flagcdn.com/au.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Austria", official: "Austria" },
    cca2: "AT",
    cca3: "AUT",
    flags: {
      png: "https://flagcdn.com/w40/at.png",
      svg: "https://flagcdn.com/at.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Azerbaijan", official: "Azerbaijan" },
    cca2: "AZ",
    cca3: "AZE",
    flags: {
      png: "https://flagcdn.com/w40/az.png",
      svg: "https://flagcdn.com/az.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Bahamas", official: "Bahamas" },
    cca2: "BS",
    cca3: "BHS",
    flags: {
      png: "https://flagcdn.com/w40/bs.png",
      svg: "https://flagcdn.com/bs.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Bahrain", official: "Bahrain" },
    cca2: "BH",
    cca3: "BHR",
    flags: {
      png: "https://flagcdn.com/w40/bh.png",
      svg: "https://flagcdn.com/bh.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Bangladesh", official: "Bangladesh" },
    cca2: "BD",
    cca3: "BGD",
    flags: {
      png: "https://flagcdn.com/w40/bd.png",
      svg: "https://flagcdn.com/bd.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Barbados", official: "Barbados" },
    cca2: "BB",
    cca3: "BRB",
    flags: {
      png: "https://flagcdn.com/w40/bb.png",
      svg: "https://flagcdn.com/bb.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Belarus", official: "Belarus" },
    cca2: "BY",
    cca3: "BLR",
    flags: {
      png: "https://flagcdn.com/w40/by.png",
      svg: "https://flagcdn.com/by.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Belgium", official: "Belgium" },
    cca2: "BE",
    cca3: "BEL",
    flags: {
      png: "https://flagcdn.com/w40/be.png",
      svg: "https://flagcdn.com/be.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Belize", official: "Belize" },
    cca2: "BZ",
    cca3: "BLZ",
    flags: {
      png: "https://flagcdn.com/w40/bz.png",
      svg: "https://flagcdn.com/bz.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Benin", official: "Benin" },
    cca2: "BJ",
    cca3: "BEN",
    flags: {
      png: "https://flagcdn.com/w40/bj.png",
      svg: "https://flagcdn.com/bj.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Bhutan", official: "Bhutan" },
    cca2: "BT",
    cca3: "BTN",
    flags: {
      png: "https://flagcdn.com/w40/bt.png",
      svg: "https://flagcdn.com/bt.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Bolivia", official: "Bolivia" },
    cca2: "BO",
    cca3: "BOL",
    flags: {
      png: "https://flagcdn.com/w40/bo.png",
      svg: "https://flagcdn.com/bo.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Bosnia and Herzegovina", official: "Bosnia and Herzegovina" },
    cca2: "BA",
    cca3: "BIH",
    flags: {
      png: "https://flagcdn.com/w40/ba.png",
      svg: "https://flagcdn.com/ba.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Botswana", official: "Botswana" },
    cca2: "BW",
    cca3: "BWA",
    flags: {
      png: "https://flagcdn.com/w40/bw.png",
      svg: "https://flagcdn.com/bw.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Brazil", official: "Brazil" },
    cca2: "BR",
    cca3: "BRA",
    flags: {
      png: "https://flagcdn.com/w40/br.png",
      svg: "https://flagcdn.com/br.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Brunei", official: "Brunei" },
    cca2: "BN",
    cca3: "BRN",
    flags: {
      png: "https://flagcdn.com/w40/bn.png",
      svg: "https://flagcdn.com/bn.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Bulgaria", official: "Bulgaria" },
    cca2: "BG",
    cca3: "BGR",
    flags: {
      png: "https://flagcdn.com/w40/bg.png",
      svg: "https://flagcdn.com/bg.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Burkina Faso", official: "Burkina Faso" },
    cca2: "BF",
    cca3: "BFA",
    flags: {
      png: "https://flagcdn.com/w40/bf.png",
      svg: "https://flagcdn.com/bf.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Burundi", official: "Burundi" },
    cca2: "BI",
    cca3: "BDI",
    flags: {
      png: "https://flagcdn.com/w40/bi.png",
      svg: "https://flagcdn.com/bi.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Cabo Verde", official: "Cabo Verde" },
    cca2: "CV",
    cca3: "CPV",
    flags: {
      png: "https://flagcdn.com/w40/cv.png",
      svg: "https://flagcdn.com/cv.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Cambodia", official: "Cambodia" },
    cca2: "KH",
    cca3: "KHM",
    flags: {
      png: "https://flagcdn.com/w40/kh.png",
      svg: "https://flagcdn.com/kh.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Cameroon", official: "Cameroon" },
    cca2: "CM",
    cca3: "CMR",
    flags: {
      png: "https://flagcdn.com/w40/cm.png",
      svg: "https://flagcdn.com/cm.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Canada", official: "Canada" },
    cca2: "CA",
    cca3: "CAN",
    flags: {
      png: "https://flagcdn.com/w40/ca.png",
      svg: "https://flagcdn.com/ca.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Central African Republic", official: "Central African Republic" },
    cca2: "CF",
    cca3: "CAF",
    flags: {
      png: "https://flagcdn.com/w40/cf.png",
      svg: "https://flagcdn.com/cf.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Chad", official: "Chad" },
    cca2: "TD",
    cca3: "TCD",
    flags: {
      png: "https://flagcdn.com/w40/td.png",
      svg: "https://flagcdn.com/td.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Chile", official: "Chile" },
    cca2: "CL",
    cca3: "CHL",
    flags: {
      png: "https://flagcdn.com/w40/cl.png",
      svg: "https://flagcdn.com/cl.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "China", official: "China" },
    cca2: "CN",
    cca3: "CHN",
    flags: {
      png: "https://flagcdn.com/w40/cn.png",
      svg: "https://flagcdn.com/cn.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Colombia", official: "Colombia" },
    cca2: "CO",
    cca3: "COL",
    flags: {
      png: "https://flagcdn.com/w40/co.png",
      svg: "https://flagcdn.com/co.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Comoros", official: "Comoros" },
    cca2: "KM",
    cca3: "COM",
    flags: {
      png: "https://flagcdn.com/w40/km.png",
      svg: "https://flagcdn.com/km.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Congo", official: "Congo" },
    cca2: "CG",
    cca3: "COG",
    flags: {
      png: "https://flagcdn.com/w40/cg.png",
      svg: "https://flagcdn.com/cg.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Costa Rica", official: "Costa Rica" },
    cca2: "CR",
    cca3: "CRI",
    flags: {
      png: "https://flagcdn.com/w40/cr.png",
      svg: "https://flagcdn.com/cr.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Croatia", official: "Croatia" },
    cca2: "HR",
    cca3: "HRV",
    flags: {
      png: "https://flagcdn.com/w40/hr.png",
      svg: "https://flagcdn.com/hr.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Cuba", official: "Cuba" },
    cca2: "CU",
    cca3: "CUB",
    flags: {
      png: "https://flagcdn.com/w40/cu.png",
      svg: "https://flagcdn.com/cu.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Cyprus", official: "Cyprus" },
    cca2: "CY",
    cca3: "CYP",
    flags: {
      png: "https://flagcdn.com/w40/cy.png",
      svg: "https://flagcdn.com/cy.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Czechia", official: "Czechia" },
    cca2: "CZ",
    cca3: "CZE",
    flags: {
      png: "https://flagcdn.com/w40/cz.png",
      svg: "https://flagcdn.com/cz.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Democratic Republic of the Congo", official: "Democratic Republic of the Congo" },
    cca2: "CD",
    cca3: "COD",
    flags: {
      png: "https://flagcdn.com/w40/cd.png",
      svg: "https://flagcdn.com/cd.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Denmark", official: "Denmark" },
    cca2: "DK",
    cca3: "DNK",
    flags: {
      png: "https://flagcdn.com/w40/dk.png",
      svg: "https://flagcdn.com/dk.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Djibouti", official: "Djibouti" },
    cca2: "DJ",
    cca3: "DJI",
    flags: {
      png: "https://flagcdn.com/w40/dj.png",
      svg: "https://flagcdn.com/dj.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Dominica", official: "Dominica" },
    cca2: "DM",
    cca3: "DMA",
    flags: {
      png: "https://flagcdn.com/w40/dm.png",
      svg: "https://flagcdn.com/dm.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Dominican Republic", official: "Dominican Republic" },
    cca2: "DO",
    cca3: "DOM",
    flags: {
      png: "https://flagcdn.com/w40/do.png",
      svg: "https://flagcdn.com/do.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Ecuador", official: "Ecuador" },
    cca2: "EC",
    cca3: "ECU",
    flags: {
      png: "https://flagcdn.com/w40/ec.png",
      svg: "https://flagcdn.com/ec.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Egypt", official: "Egypt" },
    cca2: "EG",
    cca3: "EGY",
    flags: {
      png: "https://flagcdn.com/w40/eg.png",
      svg: "https://flagcdn.com/eg.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "El Salvador", official: "El Salvador" },
    cca2: "SV",
    cca3: "SLV",
    flags: {
      png: "https://flagcdn.com/w40/sv.png",
      svg: "https://flagcdn.com/sv.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Equatorial Guinea", official: "Equatorial Guinea" },
    cca2: "GQ",
    cca3: "GNQ",
    flags: {
      png: "https://flagcdn.com/w40/gq.png",
      svg: "https://flagcdn.com/gq.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Eritrea", official: "Eritrea" },
    cca2: "ER",
    cca3: "ERI",
    flags: {
      png: "https://flagcdn.com/w40/er.png",
      svg: "https://flagcdn.com/er.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Estonia", official: "Estonia" },
    cca2: "EE",
    cca3: "EST",
    flags: {
      png: "https://flagcdn.com/w40/ee.png",
      svg: "https://flagcdn.com/ee.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Eswatini", official: "Eswatini" },
    cca2: "SZ",
    cca3: "SWZ",
    flags: {
      png: "https://flagcdn.com/w40/sz.png",
      svg: "https://flagcdn.com/sz.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Ethiopia", official: "Ethiopia" },
    cca2: "ET",
    cca3: "ETH",
    flags: {
      png: "https://flagcdn.com/w40/et.png",
      svg: "https://flagcdn.com/et.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Fiji", official: "Fiji" },
    cca2: "FJ",
    cca3: "FJI",
    flags: {
      png: "https://flagcdn.com/w40/fj.png",
      svg: "https://flagcdn.com/fj.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Finland", official: "Finland" },
    cca2: "FI",
    cca3: "FIN",
    flags: {
      png: "https://flagcdn.com/w40/fi.png",
      svg: "https://flagcdn.com/fi.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "France", official: "France" },
    cca2: "FR",
    cca3: "FRA",
    flags: {
      png: "https://flagcdn.com/w40/fr.png",
      svg: "https://flagcdn.com/fr.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Gabon", official: "Gabon" },
    cca2: "GA",
    cca3: "GAB",
    flags: {
      png: "https://flagcdn.com/w40/ga.png",
      svg: "https://flagcdn.com/ga.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Gambia", official: "Gambia" },
    cca2: "GM",
    cca3: "GMB",
    flags: {
      png: "https://flagcdn.com/w40/gm.png",
      svg: "https://flagcdn.com/gm.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Georgia", official: "Georgia" },
    cca2: "GE",
    cca3: "GEO",
    flags: {
      png: "https://flagcdn.com/w40/ge.png",
      svg: "https://flagcdn.com/ge.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Germany", official: "Germany" },
    cca2: "DE",
    cca3: "DEU",
    flags: {
      png: "https://flagcdn.com/w40/de.png",
      svg: "https://flagcdn.com/de.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Ghana", official: "Ghana" },
    cca2: "GH",
    cca3: "GHA",
    flags: {
      png: "https://flagcdn.com/w40/gh.png",
      svg: "https://flagcdn.com/gh.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Greece", official: "Greece" },
    cca2: "GR",
    cca3: "GRC",
    flags: {
      png: "https://flagcdn.com/w40/gr.png",
      svg: "https://flagcdn.com/gr.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Grenada", official: "Grenada" },
    cca2: "GD",
    cca3: "GRD",
    flags: {
      png: "https://flagcdn.com/w40/gd.png",
      svg: "https://flagcdn.com/gd.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Guatemala", official: "Guatemala" },
    cca2: "GT",
    cca3: "GTM",
    flags: {
      png: "https://flagcdn.com/w40/gt.png",
      svg: "https://flagcdn.com/gt.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Guinea", official: "Guinea" },
    cca2: "GN",
    cca3: "GIN",
    flags: {
      png: "https://flagcdn.com/w40/gn.png",
      svg: "https://flagcdn.com/gn.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Guinea-Bissau", official: "Guinea-Bissau" },
    cca2: "GW",
    cca3: "GNB",
    flags: {
      png: "https://flagcdn.com/w40/gw.png",
      svg: "https://flagcdn.com/gw.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Guyana", official: "Guyana" },
    cca2: "GY",
    cca3: "GUY",
    flags: {
      png: "https://flagcdn.com/w40/gy.png",
      svg: "https://flagcdn.com/gy.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Haiti", official: "Haiti" },
    cca2: "HT",
    cca3: "HTI",
    flags: {
      png: "https://flagcdn.com/w40/ht.png",
      svg: "https://flagcdn.com/ht.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Honduras", official: "Honduras" },
    cca2: "HN",
    cca3: "HND",
    flags: {
      png: "https://flagcdn.com/w40/hn.png",
      svg: "https://flagcdn.com/hn.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Hungary", official: "Hungary" },
    cca2: "HU",
    cca3: "HUN",
    flags: {
      png: "https://flagcdn.com/w40/hu.png",
      svg: "https://flagcdn.com/hu.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Iceland", official: "Iceland" },
    cca2: "IS",
    cca3: "ISL",
    flags: {
      png: "https://flagcdn.com/w40/is.png",
      svg: "https://flagcdn.com/is.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "India", official: "India" },
    cca2: "IN",
    cca3: "IND",
    flags: {
      png: "https://flagcdn.com/w40/in.png",
      svg: "https://flagcdn.com/in.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Indonesia", official: "Indonesia" },
    cca2: "ID",
    cca3: "IDN",
    flags: {
      png: "https://flagcdn.com/w40/id.png",
      svg: "https://flagcdn.com/id.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Iran", official: "Iran" },
    cca2: "IR",
    cca3: "IRN",
    flags: {
      png: "https://flagcdn.com/w40/ir.png",
      svg: "https://flagcdn.com/ir.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Iraq", official: "Iraq" },
    cca2: "IQ",
    cca3: "IRQ",
    flags: {
      png: "https://flagcdn.com/w40/iq.png",
      svg: "https://flagcdn.com/iq.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Ireland", official: "Ireland" },
    cca2: "IE",
    cca3: "IRL",
    flags: {
      png: "https://flagcdn.com/w40/ie.png",
      svg: "https://flagcdn.com/ie.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Israel", official: "Israel" },
    cca2: "IL",
    cca3: "ISR",
    flags: {
      png: "https://flagcdn.com/w40/il.png",
      svg: "https://flagcdn.com/il.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Italy", official: "Italy" },
    cca2: "IT",
    cca3: "ITA",
    flags: {
      png: "https://flagcdn.com/w40/it.png",
      svg: "https://flagcdn.com/it.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Ivory Coast", official: "Ivory Coast" },
    cca2: "CI",
    cca3: "CIV",
    flags: {
      png: "https://flagcdn.com/w40/ci.png",
      svg: "https://flagcdn.com/ci.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Jamaica", official: "Jamaica" },
    cca2: "JM",
    cca3: "JAM",
    flags: {
      png: "https://flagcdn.com/w40/jm.png",
      svg: "https://flagcdn.com/jm.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Japan", official: "Japan" },
    cca2: "JP",
    cca3: "JPN",
    flags: {
      png: "https://flagcdn.com/w40/jp.png",
      svg: "https://flagcdn.com/jp.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Jordan", official: "Jordan" },
    cca2: "JO",
    cca3: "JOR",
    flags: {
      png: "https://flagcdn.com/w40/jo.png",
      svg: "https://flagcdn.com/jo.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Kazakhstan", official: "Kazakhstan" },
    cca2: "KZ",
    cca3: "KAZ",
    flags: {
      png: "https://flagcdn.com/w40/kz.png",
      svg: "https://flagcdn.com/kz.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Kenya", official: "Kenya" },
    cca2: "KE",
    cca3: "KEN",
    flags: {
      png: "https://flagcdn.com/w40/ke.png",
      svg: "https://flagcdn.com/ke.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Kiribati", official: "Kiribati" },
    cca2: "KI",
    cca3: "KIR",
    flags: {
      png: "https://flagcdn.com/w40/ki.png",
      svg: "https://flagcdn.com/ki.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Kuwait", official: "Kuwait" },
    cca2: "KW",
    cca3: "KWT",
    flags: {
      png: "https://flagcdn.com/w40/kw.png",
      svg: "https://flagcdn.com/kw.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Kyrgyzstan", official: "Kyrgyzstan" },
    cca2: "KG",
    cca3: "KGZ",
    flags: {
      png: "https://flagcdn.com/w40/kg.png",
      svg: "https://flagcdn.com/kg.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Laos", official: "Laos" },
    cca2: "LA",
    cca3: "LAO",
    flags: {
      png: "https://flagcdn.com/w40/la.png",
      svg: "https://flagcdn.com/la.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Latvia", official: "Latvia" },
    cca2: "LV",
    cca3: "LVA",
    flags: {
      png: "https://flagcdn.com/w40/lv.png",
      svg: "https://flagcdn.com/lv.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Lebanon", official: "Lebanon" },
    cca2: "LB",
    cca3: "LBN",
    flags: {
      png: "https://flagcdn.com/w40/lb.png",
      svg: "https://flagcdn.com/lb.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Lesotho", official: "Lesotho" },
    cca2: "LS",
    cca3: "LSO",
    flags: {
      png: "https://flagcdn.com/w40/ls.png",
      svg: "https://flagcdn.com/ls.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Liberia", official: "Liberia" },
    cca2: "LR",
    cca3: "LBR",
    flags: {
      png: "https://flagcdn.com/w40/lr.png",
      svg: "https://flagcdn.com/lr.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Libya", official: "Libya" },
    cca2: "LY",
    cca3: "LBY",
    flags: {
      png: "https://flagcdn.com/w40/ly.png",
      svg: "https://flagcdn.com/ly.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Liechtenstein", official: "Liechtenstein" },
    cca2: "LI",
    cca3: "LIE",
    flags: {
      png: "https://flagcdn.com/w40/li.png",
      svg: "https://flagcdn.com/li.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Lithuania", official: "Lithuania" },
    cca2: "LT",
    cca3: "LTU",
    flags: {
      png: "https://flagcdn.com/w40/lt.png",
      svg: "https://flagcdn.com/lt.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Luxembourg", official: "Luxembourg" },
    cca2: "LU",
    cca3: "LUX",
    flags: {
      png: "https://flagcdn.com/w40/lu.png",
      svg: "https://flagcdn.com/lu.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Madagascar", official: "Madagascar" },
    cca2: "MG",
    cca3: "MDG",
    flags: {
      png: "https://flagcdn.com/w40/mg.png",
      svg: "https://flagcdn.com/mg.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Malawi", official: "Malawi" },
    cca2: "MW",
    cca3: "MWI",
    flags: {
      png: "https://flagcdn.com/w40/mw.png",
      svg: "https://flagcdn.com/mw.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Malaysia", official: "Malaysia" },
    cca2: "MY",
    cca3: "MYS",
    flags: {
      png: "https://flagcdn.com/w40/my.png",
      svg: "https://flagcdn.com/my.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Maldives", official: "Maldives" },
    cca2: "MV",
    cca3: "MDV",
    flags: {
      png: "https://flagcdn.com/w40/mv.png",
      svg: "https://flagcdn.com/mv.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Mali", official: "Mali" },
    cca2: "ML",
    cca3: "MLI",
    flags: {
      png: "https://flagcdn.com/w40/ml.png",
      svg: "https://flagcdn.com/ml.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Malta", official: "Malta" },
    cca2: "MT",
    cca3: "MLT",
    flags: {
      png: "https://flagcdn.com/w40/mt.png",
      svg: "https://flagcdn.com/mt.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Marshall Islands", official: "Marshall Islands" },
    cca2: "MH",
    cca3: "MHL",
    flags: {
      png: "https://flagcdn.com/w40/mh.png",
      svg: "https://flagcdn.com/mh.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Mauritania", official: "Mauritania" },
    cca2: "MR",
    cca3: "MRT",
    flags: {
      png: "https://flagcdn.com/w40/mr.png",
      svg: "https://flagcdn.com/mr.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Mauritius", official: "Mauritius" },
    cca2: "MU",
    cca3: "MUS",
    flags: {
      png: "https://flagcdn.com/w40/mu.png",
      svg: "https://flagcdn.com/mu.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Mexico", official: "Mexico" },
    cca2: "MX",
    cca3: "MEX",
    flags: {
      png: "https://flagcdn.com/w40/mx.png",
      svg: "https://flagcdn.com/mx.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Micronesia", official: "Micronesia" },
    cca2: "FM",
    cca3: "FSM",
    flags: {
      png: "https://flagcdn.com/w40/fm.png",
      svg: "https://flagcdn.com/fm.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Moldova", official: "Moldova" },
    cca2: "MD",
    cca3: "MDA",
    flags: {
      png: "https://flagcdn.com/w40/md.png",
      svg: "https://flagcdn.com/md.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Monaco", official: "Monaco" },
    cca2: "MC",
    cca3: "MCO",
    flags: {
      png: "https://flagcdn.com/w40/mc.png",
      svg: "https://flagcdn.com/mc.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Mongolia", official: "Mongolia" },
    cca2: "MN",
    cca3: "MNG",
    flags: {
      png: "https://flagcdn.com/w40/mn.png",
      svg: "https://flagcdn.com/mn.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Montenegro", official: "Montenegro" },
    cca2: "ME",
    cca3: "MNE",
    flags: {
      png: "https://flagcdn.com/w40/me.png",
      svg: "https://flagcdn.com/me.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Morocco", official: "Morocco" },
    cca2: "MA",
    cca3: "MAR",
    flags: {
      png: "https://flagcdn.com/w40/ma.png",
      svg: "https://flagcdn.com/ma.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Mozambique", official: "Mozambique" },
    cca2: "MZ",
    cca3: "MOZ",
    flags: {
      png: "https://flagcdn.com/w40/mz.png",
      svg: "https://flagcdn.com/mz.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Myanmar", official: "Myanmar" },
    cca2: "MM",
    cca3: "MMR",
    flags: {
      png: "https://flagcdn.com/w40/mm.png",
      svg: "https://flagcdn.com/mm.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Namibia", official: "Namibia" },
    cca2: "NA",
    cca3: "NAM",
    flags: {
      png: "https://flagcdn.com/w40/na.png",
      svg: "https://flagcdn.com/na.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Nauru", official: "Nauru" },
    cca2: "NR",
    cca3: "NRU",
    flags: {
      png: "https://flagcdn.com/w40/nr.png",
      svg: "https://flagcdn.com/nr.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Nepal", official: "Nepal" },
    cca2: "NP",
    cca3: "NPL",
    flags: {
      png: "https://flagcdn.com/w40/np.png",
      svg: "https://flagcdn.com/np.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Netherlands", official: "Netherlands" },
    cca2: "NL",
    cca3: "NLD",
    flags: {
      png: "https://flagcdn.com/w40/nl.png",
      svg: "https://flagcdn.com/nl.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "New Zealand", official: "New Zealand" },
    cca2: "NZ",
    cca3: "NZL",
    flags: {
      png: "https://flagcdn.com/w40/nz.png",
      svg: "https://flagcdn.com/nz.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Nicaragua", official: "Nicaragua" },
    cca2: "NI",
    cca3: "NIC",
    flags: {
      png: "https://flagcdn.com/w40/ni.png",
      svg: "https://flagcdn.com/ni.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Niger", official: "Niger" },
    cca2: "NE",
    cca3: "NER",
    flags: {
      png: "https://flagcdn.com/w40/ne.png",
      svg: "https://flagcdn.com/ne.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Nigeria", official: "Nigeria" },
    cca2: "NG",
    cca3: "NGA",
    flags: {
      png: "https://flagcdn.com/w40/ng.png",
      svg: "https://flagcdn.com/ng.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "North Korea", official: "North Korea" },
    cca2: "KP",
    cca3: "PRK",
    flags: {
      png: "https://flagcdn.com/w40/kp.png",
      svg: "https://flagcdn.com/kp.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "North Macedonia", official: "North Macedonia" },
    cca2: "MK",
    cca3: "MKD",
    flags: {
      png: "https://flagcdn.com/w40/mk.png",
      svg: "https://flagcdn.com/mk.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Norway", official: "Norway" },
    cca2: "NO",
    cca3: "NOR",
    flags: {
      png: "https://flagcdn.com/w40/no.png",
      svg: "https://flagcdn.com/no.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Oman", official: "Oman" },
    cca2: "OM",
    cca3: "OMN",
    flags: {
      png: "https://flagcdn.com/w40/om.png",
      svg: "https://flagcdn.com/om.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Pakistan", official: "Pakistan" },
    cca2: "PK",
    cca3: "PAK",
    flags: {
      png: "https://flagcdn.com/w40/pk.png",
      svg: "https://flagcdn.com/pk.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Palau", official: "Palau" },
    cca2: "PW",
    cca3: "PLW",
    flags: {
      png: "https://flagcdn.com/w40/pw.png",
      svg: "https://flagcdn.com/pw.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Palestine", official: "Palestine" },
    cca2: "PS",
    cca3: "PSE",
    flags: {
      png: "https://flagcdn.com/w40/ps.png",
      svg: "https://flagcdn.com/ps.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Panama", official: "Panama" },
    cca2: "PA",
    cca3: "PAN",
    flags: {
      png: "https://flagcdn.com/w40/pa.png",
      svg: "https://flagcdn.com/pa.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Papua New Guinea", official: "Papua New Guinea" },
    cca2: "PG",
    cca3: "PNG",
    flags: {
      png: "https://flagcdn.com/w40/pg.png",
      svg: "https://flagcdn.com/pg.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Paraguay", official: "Paraguay" },
    cca2: "PY",
    cca3: "PRY",
    flags: {
      png: "https://flagcdn.com/w40/py.png",
      svg: "https://flagcdn.com/py.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Peru", official: "Peru" },
    cca2: "PE",
    cca3: "PER",
    flags: {
      png: "https://flagcdn.com/w40/pe.png",
      svg: "https://flagcdn.com/pe.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Philippines", official: "Philippines" },
    cca2: "PH",
    cca3: "PHL",
    flags: {
      png: "https://flagcdn.com/w40/ph.png",
      svg: "https://flagcdn.com/ph.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Poland", official: "Poland" },
    cca2: "PL",
    cca3: "POL",
    flags: {
      png: "https://flagcdn.com/w40/pl.png",
      svg: "https://flagcdn.com/pl.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Portugal", official: "Portugal" },
    cca2: "PT",
    cca3: "PRT",
    flags: {
      png: "https://flagcdn.com/w40/pt.png",
      svg: "https://flagcdn.com/pt.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Qatar", official: "Qatar" },
    cca2: "QA",
    cca3: "QAT",
    flags: {
      png: "https://flagcdn.com/w40/qa.png",
      svg: "https://flagcdn.com/qa.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Romania", official: "Romania" },
    cca2: "RO",
    cca3: "ROU",
    flags: {
      png: "https://flagcdn.com/w40/ro.png",
      svg: "https://flagcdn.com/ro.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Russia", official: "Russia" },
    cca2: "RU",
    cca3: "RUS",
    flags: {
      png: "https://flagcdn.com/w40/ru.png",
      svg: "https://flagcdn.com/ru.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Rwanda", official: "Rwanda" },
    cca2: "RW",
    cca3: "RWA",
    flags: {
      png: "https://flagcdn.com/w40/rw.png",
      svg: "https://flagcdn.com/rw.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Saint Kitts and Nevis", official: "Saint Kitts and Nevis" },
    cca2: "KN",
    cca3: "KNA",
    flags: {
      png: "https://flagcdn.com/w40/kn.png",
      svg: "https://flagcdn.com/kn.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Saint Lucia", official: "Saint Lucia" },
    cca2: "LC",
    cca3: "LCA",
    flags: {
      png: "https://flagcdn.com/w40/lc.png",
      svg: "https://flagcdn.com/lc.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Saint Vincent and the Grenadines", official: "Saint Vincent and the Grenadines" },
    cca2: "VC",
    cca3: "VCT",
    flags: {
      png: "https://flagcdn.com/w40/vc.png",
      svg: "https://flagcdn.com/vc.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Samoa", official: "Samoa" },
    cca2: "WS",
    cca3: "WSM",
    flags: {
      png: "https://flagcdn.com/w40/ws.png",
      svg: "https://flagcdn.com/ws.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "San Marino", official: "San Marino" },
    cca2: "SM",
    cca3: "SMR",
    flags: {
      png: "https://flagcdn.com/w40/sm.png",
      svg: "https://flagcdn.com/sm.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Sao Tome and Principe", official: "Sao Tome and Principe" },
    cca2: "ST",
    cca3: "STP",
    flags: {
      png: "https://flagcdn.com/w40/st.png",
      svg: "https://flagcdn.com/st.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Saudi Arabia", official: "Saudi Arabia" },
    cca2: "SA",
    cca3: "SAU",
    flags: {
      png: "https://flagcdn.com/w40/sa.png",
      svg: "https://flagcdn.com/sa.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Senegal", official: "Senegal" },
    cca2: "SN",
    cca3: "SEN",
    flags: {
      png: "https://flagcdn.com/w40/sn.png",
      svg: "https://flagcdn.com/sn.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Serbia", official: "Serbia" },
    cca2: "RS",
    cca3: "SRB",
    flags: {
      png: "https://flagcdn.com/w40/rs.png",
      svg: "https://flagcdn.com/rs.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Seychelles", official: "Seychelles" },
    cca2: "SC",
    cca3: "SYC",
    flags: {
      png: "https://flagcdn.com/w40/sc.png",
      svg: "https://flagcdn.com/sc.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Sierra Leone", official: "Sierra Leone" },
    cca2: "SL",
    cca3: "SLE",
    flags: {
      png: "https://flagcdn.com/w40/sl.png",
      svg: "https://flagcdn.com/sl.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Singapore", official: "Singapore" },
    cca2: "SG",
    cca3: "SGP",
    flags: {
      png: "https://flagcdn.com/w40/sg.png",
      svg: "https://flagcdn.com/sg.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Slovakia", official: "Slovakia" },
    cca2: "SK",
    cca3: "SVK",
    flags: {
      png: "https://flagcdn.com/w40/sk.png",
      svg: "https://flagcdn.com/sk.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Slovenia", official: "Slovenia" },
    cca2: "SI",
    cca3: "SVN",
    flags: {
      png: "https://flagcdn.com/w40/si.png",
      svg: "https://flagcdn.com/si.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Solomon Islands", official: "Solomon Islands" },
    cca2: "SB",
    cca3: "SLB",
    flags: {
      png: "https://flagcdn.com/w40/sb.png",
      svg: "https://flagcdn.com/sb.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Somalia", official: "Somalia" },
    cca2: "SO",
    cca3: "SOM",
    flags: {
      png: "https://flagcdn.com/w40/so.png",
      svg: "https://flagcdn.com/so.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "South Africa", official: "South Africa" },
    cca2: "ZA",
    cca3: "ZAF",
    flags: {
      png: "https://flagcdn.com/w40/za.png",
      svg: "https://flagcdn.com/za.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "South Korea", official: "South Korea" },
    cca2: "KR",
    cca3: "KOR",
    flags: {
      png: "https://flagcdn.com/w40/kr.png",
      svg: "https://flagcdn.com/kr.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "South Sudan", official: "South Sudan" },
    cca2: "SS",
    cca3: "SSD",
    flags: {
      png: "https://flagcdn.com/w40/ss.png",
      svg: "https://flagcdn.com/ss.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Spain", official: "Spain" },
    cca2: "ES",
    cca3: "ESP",
    flags: {
      png: "https://flagcdn.com/w40/es.png",
      svg: "https://flagcdn.com/es.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Sri Lanka", official: "Sri Lanka" },
    cca2: "LK",
    cca3: "LKA",
    flags: {
      png: "https://flagcdn.com/w40/lk.png",
      svg: "https://flagcdn.com/lk.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Sudan", official: "Sudan" },
    cca2: "SD",
    cca3: "SDN",
    flags: {
      png: "https://flagcdn.com/w40/sd.png",
      svg: "https://flagcdn.com/sd.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Suriname", official: "Suriname" },
    cca2: "SR",
    cca3: "SUR",
    flags: {
      png: "https://flagcdn.com/w40/sr.png",
      svg: "https://flagcdn.com/sr.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Sweden", official: "Sweden" },
    cca2: "SE",
    cca3: "SWE",
    flags: {
      png: "https://flagcdn.com/w40/se.png",
      svg: "https://flagcdn.com/se.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Switzerland", official: "Switzerland" },
    cca2: "CH",
    cca3: "CHE",
    flags: {
      png: "https://flagcdn.com/w40/ch.png",
      svg: "https://flagcdn.com/ch.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Syria", official: "Syria" },
    cca2: "SY",
    cca3: "SYR",
    flags: {
      png: "https://flagcdn.com/w40/sy.png",
      svg: "https://flagcdn.com/sy.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Taiwan", official: "Taiwan" },
    cca2: "TW",
    cca3: "TWN",
    flags: {
      png: "https://flagcdn.com/w40/tw.png",
      svg: "https://flagcdn.com/tw.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Tajikistan", official: "Tajikistan" },
    cca2: "TJ",
    cca3: "TJK",
    flags: {
      png: "https://flagcdn.com/w40/tj.png",
      svg: "https://flagcdn.com/tj.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Tanzania", official: "Tanzania" },
    cca2: "TZ",
    cca3: "TZA",
    flags: {
      png: "https://flagcdn.com/w40/tz.png",
      svg: "https://flagcdn.com/tz.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Thailand", official: "Thailand" },
    cca2: "TH",
    cca3: "THA",
    flags: {
      png: "https://flagcdn.com/w40/th.png",
      svg: "https://flagcdn.com/th.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Timor-Leste", official: "Timor-Leste" },
    cca2: "TL",
    cca3: "TLS",
    flags: {
      png: "https://flagcdn.com/w40/tl.png",
      svg: "https://flagcdn.com/tl.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Togo", official: "Togo" },
    cca2: "TG",
    cca3: "TGO",
    flags: {
      png: "https://flagcdn.com/w40/tg.png",
      svg: "https://flagcdn.com/tg.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Tonga", official: "Tonga" },
    cca2: "TO",
    cca3: "TON",
    flags: {
      png: "https://flagcdn.com/w40/to.png",
      svg: "https://flagcdn.com/to.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Trinidad and Tobago", official: "Trinidad and Tobago" },
    cca2: "TT",
    cca3: "TTO",
    flags: {
      png: "https://flagcdn.com/w40/tt.png",
      svg: "https://flagcdn.com/tt.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Tunisia", official: "Tunisia" },
    cca2: "TN",
    cca3: "TUN",
    flags: {
      png: "https://flagcdn.com/w40/tn.png",
      svg: "https://flagcdn.com/tn.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Turkey", official: "Turkey" },
    cca2: "TR",
    cca3: "TUR",
    flags: {
      png: "https://flagcdn.com/w40/tr.png",
      svg: "https://flagcdn.com/tr.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Turkmenistan", official: "Turkmenistan" },
    cca2: "TM",
    cca3: "TKM",
    flags: {
      png: "https://flagcdn.com/w40/tm.png",
      svg: "https://flagcdn.com/tm.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Tuvalu", official: "Tuvalu" },
    cca2: "TV",
    cca3: "TUV",
    flags: {
      png: "https://flagcdn.com/w40/tv.png",
      svg: "https://flagcdn.com/tv.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Uganda", official: "Uganda" },
    cca2: "UG",
    cca3: "UGA",
    flags: {
      png: "https://flagcdn.com/w40/ug.png",
      svg: "https://flagcdn.com/ug.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Ukraine", official: "Ukraine" },
    cca2: "UA",
    cca3: "UKR",
    flags: {
      png: "https://flagcdn.com/w40/ua.png",
      svg: "https://flagcdn.com/ua.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "United Arab Emirates", official: "United Arab Emirates" },
    cca2: "AE",
    cca3: "ARE",
    flags: {
      png: "https://flagcdn.com/w40/ae.png",
      svg: "https://flagcdn.com/ae.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "United Kingdom", official: "United Kingdom" },
    cca2: "GB",
    cca3: "GBR",
    flags: {
      png: "https://flagcdn.com/w40/gb.png",
      svg: "https://flagcdn.com/gb.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "United States", official: "United States" },
    cca2: "US",
    cca3: "USA",
    flags: {
      png: "https://flagcdn.com/w40/us.png",
      svg: "https://flagcdn.com/us.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Uruguay", official: "Uruguay" },
    cca2: "UY",
    cca3: "URY",
    flags: {
      png: "https://flagcdn.com/w40/uy.png",
      svg: "https://flagcdn.com/uy.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Uzbekistan", official: "Uzbekistan" },
    cca2: "UZ",
    cca3: "UZB",
    flags: {
      png: "https://flagcdn.com/w40/uz.png",
      svg: "https://flagcdn.com/uz.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Vanuatu", official: "Vanuatu" },
    cca2: "VU",
    cca3: "VUT",
    flags: {
      png: "https://flagcdn.com/w40/vu.png",
      svg: "https://flagcdn.com/vu.svg",
    },
    region: "Oceania",
    population: 0,
  },
  {
    name: { common: "Vatican City", official: "Vatican City" },
    cca2: "VA",
    cca3: "VAT",
    flags: {
      png: "https://flagcdn.com/w40/va.png",
      svg: "https://flagcdn.com/va.svg",
    },
    region: "Europe",
    population: 0,
  },
  {
    name: { common: "Venezuela", official: "Venezuela" },
    cca2: "VE",
    cca3: "VEN",
    flags: {
      png: "https://flagcdn.com/w40/ve.png",
      svg: "https://flagcdn.com/ve.svg",
    },
    region: "Americas",
    population: 0,
  },
  {
    name: { common: "Vietnam", official: "Vietnam" },
    cca2: "VN",
    cca3: "VNM",
    flags: {
      png: "https://flagcdn.com/w40/vn.png",
      svg: "https://flagcdn.com/vn.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Yemen", official: "Yemen" },
    cca2: "YE",
    cca3: "YEM",
    flags: {
      png: "https://flagcdn.com/w40/ye.png",
      svg: "https://flagcdn.com/ye.svg",
    },
    region: "Asia",
    population: 0,
  },
  {
    name: { common: "Zambia", official: "Zambia" },
    cca2: "ZM",
    cca3: "ZMB",
    flags: {
      png: "https://flagcdn.com/w40/zm.png",
      svg: "https://flagcdn.com/zm.svg",
    },
    region: "Africa",
    population: 0,
  },
  {
    name: { common: "Zimbabwe", official: "Zimbabwe" },
    cca2: "ZW",
    cca3: "ZWE",
    flags: {
      png: "https://flagcdn.com/w40/zw.png",
      svg: "https://flagcdn.com/zw.svg",
    },
    region: "Africa",
    population: 0,
  },
];
